module.exports = __webpack_public_path__ + "02dd11c79525fcc6d13b6f2d9cf267c0.png";